class Formatter {
  static date(date) {
    return date ? new Date(date).toLocaleDateString('pt-BR') : null;
  }

  static dateTime(date) {
    if (!date) return null;
    return new Date(date).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  }

  static currency(value) {
    return (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}

export default Formatter;
